import { template as template_e0c9cbd7933742f88e151221ce9b6454 } from "@ember/template-compiler";
import BsPopover from 'eflex/components/bs-popover';
import { withDefault, isPresent } from '@eflexsystems/ember-composable-helpers';
import Link from 'eflex/components/link';
export default template_e0c9cbd7933742f88e151221ce9b6454(`
<a
  tabindex='0'
  class="badge bg-{{withDefault @type 'primary'}} pointer text-decoration-none rounded"
  ...attributes
>
  {{@label}}
  {{#if (isPresent @options)}}
    <BsPopover @triggerEvents='focus'>
      {{#each @options as |option|}}
        <div class="mb-1">
          <Link class="popover-link" @route={{@route}} @model={{option.id}}>{{yield option}}</Link>
        </div>
      {{/each}}
    </BsPopover>
  {{/if}}
</a>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
